// extracted by mini-css-extract-plugin
export var actionButton = "_r4-0";
export var actionMenuContainer = "_r4-i";
export var bubble = "_r4-2";
export var bubbleActionMenu = "_r4-j";
export var bubbleContext = "_r4-6";
export var bubbleItems = "_r4-7";
export var customer = "_r4-3";
export var divider = "_r4-8";
export var fileList = "_r4-9";
export var hiddenComment = "_r4-o";
export var infoAbove = "_r4-a";
export var internal = "_r4-4";
export var lightActionButton = "_r4-1";
export var link = "_r4-b";
export var merchant = "_r4-5";
export var message = "_r4-c";
export var profilePicture = "_r4-e";
export var quillToolbarContainer = "_r4-f";
export var senderDate = "_r4-g";
export var senderDateCustomer = "_r4-h";
export var senderName = "_r4-d";
export var time = "_r4-k";
export var uploadedImage = "_r4-l";
export var username = "_r4-m";
export var xsmall = "_r4-n";